import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import nakedNewsLogoWhite from '../../assets/Affiliate/Logos Icons/NN-logo.png';

import styles from './AdultContentWarning.module.css';


const LEAVE_URL = 'https://www.google.com';

function AdultContentWarning(props) {
  const { onEnter } = props;

  const handleEnter = useCallback(() => {
    onEnter();
  }, [onEnter]);

  const handleLeave = useCallback(() => {
    window.location.href = LEAVE_URL;
  }, []);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <h1 className={styles.title}>Adult Content Warning</h1>
        <div className={styles.content}>
          This website contains sexually explicit material intended for adults
          only. By entering, you confirm that you are at least 18 years of age
          (or the age of majority in your jurisdiction) and that you wish to
          view such material. If you are under 18, or if such material is
          illegal or offensive in your location, please leave now.
        </div>
        <div className={styles.buttonsContainer}>
          <button
            className={styles.enterButton}
            onClick={handleEnter}
          >
            I am 18 or older &mdash; Enter
          </button>
          <button
            className={styles.leaveButton}
            onClick={handleLeave}
          >
            Leave
          </button>
        </div>
        <div className={styles.logoContainer}>
          <img
            alt="Naked News: The Program With Nothing To Hide"
            className={classnames(styles.logo, 'unblurred')}
            src={nakedNewsLogoWhite}
          />
        </div>
      </div>
    </div>
  );
}

AdultContentWarning.propTypes = { onEnter: PropTypes.func.isRequired };

export default AdultContentWarning;
